"use client";

import React from "react";

import QuestionLayout from "@/app/layout/question";
import withQuoteData from "@/app/shared-components/wrappers/with-quote-data";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import CoverForDescriptionSection from "./components/description-section";
import CoverTypeFormSection from "./components/form-section";
import CoverTypeModal from "./components/form-section/form-description-section/cover-type-modal/cover-type-modal";
import useCoverTypeHook from "./hook/cover-type.hook";
import { useCoverTypeContext } from "./provider/cover-type.provider";

function CoverType() {
  const { handleSubmitButton, isFooterLoading, loading } = useCoverTypeHook();

  const { magnoliaData, selectedAnswer } = useCoverTypeContext();

  const { ctaButtonText } = magnoliaData.overlayArea[0];

  const { current } = useWizard();

  return (
    <QuestionLayout
      footer={{
        isHideFooterBack: true,
        isLoading: loading || isFooterLoading,
        isDisabledBack: false,
        isDisabledContinue: selectedAnswer === 0,
        footerActionBack: () => {},
        footerActionContinue: () => {
          handleSubmitButton();
        },
        id: "cover-type-footer",
        ctaButtonText,
      }}
      isShowDynamicFooter
      formSection={<CoverTypeFormSection />}
      descriptionContent={<CoverForDescriptionSection />}
      progressBarPercent={current.progressBarPercentage ?? 7}
    >
      <CoverTypeModal />
    </QuestionLayout>
  );
}

export default withQuoteData(CoverType);
